const validateIin = (iin: string) => {
  const value = iin?.replace(/\s/g, "");
  return /^\d{12}$/.test(value);
};

export default validateIin;
